// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-tab-pane[data-v-201e0b10] {\n  height: auto !important;\n  /* overflow-y: auto; */\n}\n", ""]);
// Exports
module.exports = exports;
